import { Button, Hr } from 'LocalGluons';
import React, { useEffect, useState } from 'react';
import { View, Text, Image, ImageStyle, BackHandler } from 'react-native';
import { t } from 'Locale';
import baseStyles from './forgNameContent.jss';
import { ScrollView } from 'react-native-gesture-handler';
import { useStore } from 'Store';

interface IForgottenNameContent {
    navigation: any;
    setModalContent: (state: any) => void;
    dataFromResponse?: any;
    setHideBackButton?: (state: boolean) => void;
}

const ForgottenNameContent: React.FC<IForgottenNameContent> = ({
    navigation,
    setModalContent,
    dataFromResponse = null,
    setHideBackButton
}) => {
    const [imageOneAspectRatio, setImageOneAspectRatio] = useState(1);
    const [imageTwoAspectRatio, setImageTwoAspectRatio] = useState(1);
    const { setHideLoginHeader } = useStore();
    const onConfirm = () => {
        setModalContent(null);
        setHideLoginHeader(false);
        navigation.pop();
    };

    const handleBack = () => {
        setModalContent(null);
        return true;
    };

    useEffect(() => {
        const listener = BackHandler.addEventListener('hardwareBackPress', handleBack);
        if (typeof setHideBackButton === 'function') {
            setHideBackButton(false);
        }
        setHideLoginHeader(false);
        return () => {
            listener?.remove();
        };
    }, []);

    useEffect(() => {
        if (dataFromResponse === null) {
            return;
        }

        Image.getSize(dataFromResponse.images[0], (width, height) => {
            const aspectRatio = width / height;
            setImageOneAspectRatio(aspectRatio);
        });
        Image.getSize(dataFromResponse.images[1], (width, height) => {
            const aspectRatio = width / height;
            setImageTwoAspectRatio(aspectRatio);
        });
    }, [
        dataFromResponse
    ]);

    const displayButton = () => {
        return (
            <View style={baseStyles.buttonSpacing}>
                <View style={baseStyles.buttonContainer}>
                    <Button
                        style={{ button: baseStyles.button, text: baseStyles.buttonText }}
                        title={t('LOGIN.HELP.USERNAME_OK_BTN_MOBILES')}
                        onPress={() => onConfirm()}
                        testID="confirm_button"
                    />

                    <Button
                        onPress={() => {
                            if (typeof setHideBackButton === 'function') {
                                setHideBackButton(false);
                            }
                            setModalContent(null);
                        }
                        }
                        style={{ button: baseStyles.button }}
                        title={t('PARTNER.VOYO.CLOSE_BTN')}
                        isSecondary
                    />
                </View>
            </View>
        );
    }

    return (
        <View style={baseStyles.felxOne}>
            <View style={baseStyles.scrollContant}>
                <View style={{ ...baseStyles.mainContainer, top: dataFromResponse !== null ? '10%' : null }}>
                    <View style={baseStyles.head}>
                        <Text style={baseStyles.title}>{t('LOGIN.HELP.USERNAME_TITLE_MOBILES')}</Text>
                        <Text style={baseStyles.subTitle}>{dataFromResponse ? t('LOGIN.HELP.USERNAME_CONTRACT_TITLE_MOBILES') : t('LOGIN.HELP.USERNAME_PREPAID_TITLE_MOBILES')}</Text>
                        <Hr />
                    </View>
                    {dataFromResponse !== null && (
                        <ScrollView>
                            <View style={baseStyles.helpContentContainer}>
                                <View style={baseStyles.contentContainer}>
                                    <Text style={baseStyles.content}>{t('LOGIN.HELP.USERNAME_CONTRACT_TEXT1_MOBILES')}</Text>
                                    <Image source={{ uri: dataFromResponse.images[0] }} style={{
                                        ...baseStyles.helpImage as ImageStyle,
                                        aspectRatio: imageOneAspectRatio
                                    }} />
                                </View>
                                <Text style={baseStyles.or}>{t('LOGIN.HELP.USERNAME_CONTRACT_OR_MOBILES')}</Text>
                                <View style={baseStyles.contentContainer}>
                                    <Text style={baseStyles.content}>{t('LOGIN.HELP.USERNAME_CONTRACT_TEXT2_MOBILES')}</Text>
                                    <Image source={{ uri: dataFromResponse.images[1] }} style={{
                                        ...baseStyles.helpImage as ImageStyle,
                                        aspectRatio: imageTwoAspectRatio
                                    }} />
                                </View>
                            </View>
                        </ScrollView>
                    )}
                    {dataFromResponse === null && (
                        <View style={baseStyles.blacBackground}>
                            <Text style={baseStyles.plainContent}>{t('LOGIN.HELP.USERNAME_PREPAID_TEXT_MOBILES')}</Text>
                            {displayButton()}
                        </View>
                    )}
                </View>
            </View>
            {dataFromResponse !== null && (
                <>{displayButton()}</>
            )}
        </View>


    );
};

export default ForgottenNameContent;